import {Dialog, DialogActions, DialogContent, DialogTitle, Step, StepLabel, Stepper} from "@mui/material";
import {useEffect, useState} from "react";
import TextFieldValidation from "../TextFieldValidation";
import {gluing} from "../../../../../data/Gluing";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MaterialPageItemModule from "../../../modul/MaterialPageItemModule";
import ButtonAdd from "../../../button/ButtonAdd";
import ButtonExit from "../../../button/ButtonExit";
import ButtonBack from "../../../button/ButtonBack";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import MaterialEstimateUnitService from "../../../../../API/orders/estimate/organization/MaterialEstimateUnitService";
import MaterialForRequestsCuttingTable from "../../orders/organization/MaterialForRequestsCuttingTable";

const ModalAddEdges = ({
                           initValue,
                           open,
                           onClose,
                           title,
                           handleSubmit,
                           handleModalAlert,
                           byMaterialEstimateUnit,
                           orderId,
                           replace,
                           loading,
                           modelOrComposition
                       }) => {
    const allGluing = Object.entries(gluing)
    const [activeStep, setActiveStep] = useState(0)
    const steps = modelOrComposition ? [
        'Способ поклейки',
        'Материал',
        'Комментарий'
    ] : [
        'Материал',
        'Способ поклейки',
        'Комментарий'
    ];

    const [data, setData] = useState(initValue)
    const [materials, setMaterials] = useState([{}])
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 10,
        totalElements: 0,
        searchData: ""
    })

    const isMaterialStep = modelOrComposition ? activeStep === 1 : activeStep === 0
    const isGluingStep = modelOrComposition ? activeStep === 0 : activeStep === 1
    const isCommentStep = activeStep === 2
    const materialName = data.material?.name || data.material?.materialOrganizationOption?.name
    const materialArticle = data.material?.articleNumber || data.material?.materialOrganizationOption?.articleNumber

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
    }

    useEffect(() => {
        if (open) {
            setData(initValue)
            setActiveStep(0)
            byMaterialEstimateUnit && !replace && !modelOrComposition && MaterialEstimateUnitService.getAllByOrderIdForOrderEdge(orderId).then(function (response) {
                let data = response.data;
                setMaterials(data);
                setData(prev => ({...prev, material: data[0]}))
                setTableOptions((prev) => ({...prev, totalElements: data.length}))
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }
    }, [open]);

    const selectGluing = (value) => {
        setData((prev) => {
            return {...prev, edgeType: value}
        })
    }
    const selectMaterial = (material) => {
        setData((value) => {
            return {...value, material: material}
        })
    }
    const submit = () => {
        if (activeStep === 0 && !replace) {
            setActiveStep(1)
        } else if (activeStep === 1) {
            setActiveStep(2)
        } else {
            const materialOption = data.material?.materialOrganizationOption
            const selectedMaterialName = data.material?.name || materialOption?.name
            const selectedShortName = data.material?.shortName || materialOption?.shortName
            const selectedArticleNumber = data.material?.articleNumber || materialOption?.articleNumber
            const newData = modelOrComposition ? {
                edgeType: data.edgeType,
                materialId: data.material?.id ?? null,
                materialName: selectedMaterialName,
                note: data.note
            } : {
                edgeType: data.edgeType,
                materialId: data.material?.id,
                materialName: selectedMaterialName,
                shortName: selectedShortName,
                materialArticleNumber: selectedArticleNumber,
                note: data.note
            }
            handleSubmit(newData, reset)
        }
    }
    const reset = () => {
        setActiveStep(0)
        onClose()
        setMaterials([{}])
    }

    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: `${isMaterialStep ? "1400px" : "800px"}`,
                height: `${isMaterialStep ? "915px" : isGluingStep ? "550px" : "430px"}`,
                borderRadius: 8,
            }
        }}>
            <Box style={{
                padding: 40,
                display: "flex",
                flexDirection: "column",
                gap: 16,
                alignItems: "center"
            }}>
                <DialogTitle sx={{
                    color: (theme) => theme.palette.text.main,
                    padding: 0,
                    fontSize: 24,
                    fontWeight: 700
                }}>{title}</DialogTitle>
                {!replace && <Stepper
                    style={{width: 700}}
                    activeStep={activeStep}
                >
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel sx={{
                                ".MuiSvgIcon-root": {
                                    fontSize: 40,
                                    color: "#737478",
                                    "&.Mui-active": {
                                        color: "#3B8BEC",
                                    }
                                },
                                "& .MuiStepLabel-label": {
                                    fontSize: 18,
                                    "&.Mui-active": {
                                        fontWeight: 700,
                                    }
                                }
                            }}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>}
            </Box>
            <Box sx={{
                height: "32px",
                fontSize: "18px",
                margin: "0px 40px 0px 40px",
                display: "flex",
                alignItems: "center",
                borderBottom: data.material?.id ? "#3B8BEC 1px solid" : "transparent 1px solid",
                '& .MuiTypography-root': {
                    fontWeight: (theme) => theme.typography.fontWeight,
                    color: (theme) => theme.palette.text.main,
                    '&:first-of-type': {
                        marginRight: '10px'
                    }
                },
            }}>
                <Typography component="p">{materialArticle}</Typography>
                <Typography component="p">{materialName}</Typography>
            </Box>
            <DialogContent sx={{padding: "0px 20px 0px 40px"}}>
                {isMaterialStep ?
                    (byMaterialEstimateUnit && !replace && !modelOrComposition) ? (materials.length === 0 ?
                            <Box sx={{display: "flex", justifyContent: "center"}}><Typography>Нет ни одного плитного
                                материала в
                                смете</Typography></Box> :
                            <MaterialForRequestsCuttingTable
                                data={materials} tableOptions={tableOptions}
                                tableOptionsHandle={tableOptionsHandle}
                                selectMaterialId={data?.material.id}
                                selectMaterial={(el) => setData(prev => ({...prev, material: el}))}
                            />) :
                        <MaterialPageItemModule
                            selectMaterialId={data.material?.id}
                            selectMaterial={selectMaterial}
                            subTypeMaterial={"EDGE"}
                            modal={true}
                            handleModalAlert={handleModalAlert}
                        />
                    : isGluingStep ?
                        <Box style={{display: "flex", flexDirection: "column"}}>

                            <Box style={{width: 300}}>
                                <RadioGroup
                                    defaultValue="female"
                                    aria-labelledby="demo-customized-radios"
                                    name="customized-radios"
                                    value={data.edgeType}
                                    onChange={(event) => selectGluing(event.target.value)}
                                >
                                    {allGluing.map((option) => (
                                            <FormControlLabel
                                                key={option[0]}
                                                value={option[0]}
                                                control={<Radio/>}
                                                label={option[1]}
                                                sx={{
                                                    width: "752px",
                                                    height: "36px",
                                                    "&:not(:last-of-type)": {
                                                        marginBottom: "4px",
                                                    },
                                                    borderBottom: (theme) => `${theme.palette.primary.stroke} solid 1px`,
                                                    "&:hover": {
                                                        backgroundColor: (theme) => theme.palette.primary.light
                                                    }
                                                }
                                                }

                                            />
                                        )
                                    )}

                                </RadioGroup>
                            </Box>
                        </Box> : isCommentStep && <Box>
                            <TextFieldValidation
                                name="note"
                                label="Коментарий"
                                value={data?.note}
                                setCurrValues={setData}
                            />
                        </Box>}
            </DialogContent>

            <DialogActions style={{padding: 40, display: "flex", justifyContent: "space-between"}}>
                <Box>{activeStep !== 0 &&
                    <ButtonBack text={"Назад"}
                                onClick={() => setActiveStep((step) => step - 1)}/>} </Box>
                <Box>
                    <ButtonExit text={"Выйти"} onClick={reset}/>
                    <ButtonAdd
                        loading={loading}
                        text={"Выбрать"}
                        onClick={submit}
                        disabled={!data.material?.id && !(modelOrComposition && activeStep === 0)}
                    />
                </Box>
            </DialogActions>
        </Dialog>
    );
}
export default ModalAddEdges
